module.exports = __webpack_public_path__ + "img/goals_requests.d756e67a.svg";